import Card from "components/Card";
import WeeklyCharts from "components/WeeklyCharts";

const WeeklyChartCard = props => {
    const {title, patientId, auth, patientSettings} = props;

    return (
        <Card className='sleep'>
            <Card.Body className='total-sleep-time'>
                <WeeklyCharts
                    patientId={patientId}
                    auth={auth}
                    patientSettings={patientSettings}
                    currentMovementScore={props.currentMovementScore}
                />
            </Card.Body>
        </Card>
    );
};

WeeklyChartCard.defaultProps = {
    title: '',
    auth: null,
    patientId: null
}

export default WeeklyChartCard;